module.exports = {
  latestClaimsDate: new Date('2025-06-30'),
};
